var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.84181 26.0817L16.2599 19.8025H0V11.819H16.2599L9.84181 5.53986L14.6328 0.785645L30 15.7659L14.6328 30.7462L9.84181 26.0817Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"30","height":"31","viewBox":"0 0 30 31","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
